import React from 'react';
import { DatePicker } from 'antd';
import Item from '../../../components/Form/Item';
import { useFormikContext, ErrorMessage } from 'formik';
import Type from './Type';
import TrainingField from './TrainingField';

const Detail = () => {
  const formik = useFormikContext();

  return (
    <>
      <h4 className="gx-text-md gx-mt-3 gx-mb-3">Update Data Training</h4>
      <Item name="Tanggal Training">
        <DatePicker
          onChange={(value) => {
            formik.setFieldValue("date.start", value.format("YYYY-MM-DD"));
          }}
          style={{ width: "100%" }}
        />
        <ErrorMessage component="div" className="gx-text-danger" name="date.start" />
      </Item>

      <Item name="Berlaku Sampai">
        <DatePicker
          onChange={(value) => {
            formik.setFieldValue("date.end", value.format("YYYY-MM-DD"));
          }}
          style={{ width: "100%" }}
        />
        <ErrorMessage component="div" className="gx-text-danger" name="date.end" />
      </Item>

      <Type />

      <TrainingField />
    </>
  );
}

export default Detail;